import * as dayjs from 'dayjs'
import * as da from 'dayjs/locale/da'

window.onload = () => {
	dayjs.locale(da)
	CheckForNewEvent()
}


async function CheckForNewEvent () {
	const event = await PostRequestAsJson<EventResponse>('/api/get_next_event', null)
	if (event.event === null) {
		console.log('No event found')
		return
	}
	console.log(event)

	var time = dayjs(event.event.time).format('D MMMM YYYY klokken HH:mm')
	console.log(time)

	var element = document.getElementById('next-event')
	if (element) {
		element.innerHTML = `Næste UnderPavillonen bliver ${time} og temaet er ${event.event.title}`
	}
}


// copied once from events.tsx, maybe should be in a shared file
function PostRequestAsJson<Type> (url, data) {
	//TODO: do idk something else than this
	let auth = 'GKzgrQzt9M7bPd1nJe0M9B0qjG4GLmyb'

	return fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			'Authorization': `Bearer ${auth}`
		},
		body: JSON.stringify(data)
	}).then(response => response.json() as Promise<Type>)
}

class EventResponse {
	event : PavillonEvent
}

class PavillonEvent {
	id    : number
	title : string
	time  : string
}